import React, { useEffect, useRef, useState } from 'react'
import parse from 'html-react-parser';
import nl2br from 'nl2br';
import '../../form.css'
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import constant from '../../../../constant';
const Index = ({ items, onChange, isFinalSubmitting, setIsFinalSubmitting, onSubmit, history, siteManager }) => {

    return (
        <div className="row">
            <div className="col-md-12 ">
                <div className="appraisal-report-table-responsive">
                    <table className="assessment-table" cellSpacing={0}>
                        <tbody>
                            <tr>
                                <td className="hd-s2 pd10">
                                    {" "}
                                    <p>S.No.</p>
                                </td>
                                <td className="hd-s1 pd10">
                                    <p>ITEM DESCRIPTION</p>
                                </td>
                                <td className="hd-s1 pd10">
                                    <p>REFERENCE DOCUMENT</p>
                                </td>
                                <td className="hd-s2 w200 pd10">
                                    <p>REMARKS</p>
                                </td>
                                <td className="hd-s2 pd10" colSpan={2}>
                                    <p>
                                        <a name="bookmark0">‌</a>STATUS OF COMPLETION{" "}
                                        <a name="bookmark1">‌</a>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1" />
                                </td>
                                <td className="td-s2" />
                                <td />
                                <td />
                                <td className="check-td-s3 text-center">Yes</td>
                                <td className="check-td-s3 text-center">No</td>
                            </tr>
                            {items.map((item, idx) => (
                                <tr
                                    key={item.id || idx}
                                    className={item.active === false ? 'bg-danger text-white' : ''}
                                >
                                    <td className="td-s1">
                                        <p className="s1">{idx + 1}.</p>
                                    </td>
                                    <td className="td-s2">
                                        {parse(nl2br(item.label))}
                                    </td>
                                    <td className='tb-input-value'>
                                        <p className="s1">
                                            <input
                                                className="form-control"
                                                type="text"
                                                value={item.referenceDocument || ''}
                                                onChange={(e) =>
                                                    onChange(idx, 'referenceDocument', e.target.value)
                                                }
                                            />
                                        </p>
                                    </td>
                                    <td className='tb-input-value'>
                                        <p className="s1">
                                            <input
                                                className="form-control"
                                                type="text"
                                                value={item.remarks || ''}
                                                onChange={(e) =>
                                                    onChange(idx, 'remarks', e.target.value)
                                                }
                                            />
                                        </p>
                                    </td>
                                    <td className="td-form-check text-center ">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={item.statusOfCompletion === 'yes'}
                                            onChange={() =>
                                                onChange(
                                                    idx,
                                                    'statusOfCompletion',
                                                    item.statusOfCompletion === 'yes' ? '' : 'yes'
                                                )
                                            }
                                        />
                                    </td>
                                    <td className="td-form-check text-center">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={item.statusOfCompletion === 'no'}
                                            onChange={() =>
                                                onChange(
                                                    idx,
                                                    'statusOfCompletion',
                                                    item.statusOfCompletion === 'no' ? '' : 'no'
                                                )
                                            }
                                        />
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>
                <div className="row mt-4">
                    <div className="col-lg-12 text-left ">
                        <table className="table-bottom-sig">
                            <tbody>
                                <tr className="bottom-sig-tr2-box">
                                    <td className="input-td">
                                        <p className="s2">Signature of Site Manager:</p>
                                    </td>
                                    <td>
                                        <p className="s1">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                value={siteManager}
                                            />
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="final-checkbox">
                            <div class="form-check mt-2">
                                <input class="form-check-input" name="discountCheckbox" type="checkbox" checked={isFinalSubmitting} onChange={() => { setIsFinalSubmitting() }} id="productdiscountCheck1" />
                                <label class="form-check-label" for="productdiscountCheck1">Send New Building Pre Launching Check List to Office for Review</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-lg-12 text-left ">
                        <button
                            onClick={() => { onSubmit() }}
                            className="btn btn-success"
                            style={{
                                backgroundImage:
                                    "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                borderColor: "#2b5a7e"
                            }}
                        >
                            Submit
                        </button>
                        <button
                            type="button"
                            className="btn btn-danger ms-3"
                            style={{
                                backgroundImage:
                                    "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                borderColor: "#2b5a7e"
                            }}
                            onClick={() => { history.push(constant.Authedcomponent.production.url) }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouter(Index)